require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./posts-hello-gatsby.json") })
        }
      }, "path---posts-hello-gatsby");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---posts-hello-gatsby!./.cache/json/posts-hello-gatsby.json
// module id = 367
// module chunks = 231608221292675